import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchPositions } from "../positions/reducer";

export const handlePositionUpdate = createAsyncThunk("handlePositionUpdate", async (centerId: string, thunkAPI) => {
  await thunkAPI.dispatch(fetchPositions({ registerStockObserver: false, centerId }));
});
